function normalizar(texto) {
  if (typeof texto === 'string') {
    return texto.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }
  return '';
}

function pesquisar(texto, pesquisa) {
  return texto && normalizar(texto)
    .indexOf(normalizar(pesquisa)) !== -1;
}

function formatNomeSobrenome(nome) {
  if (typeof nome === 'string') {
    return nome.replace(' DA ', ' ')
      .replace(' DAS ', ' ')
      .replace(' DE ', ' ')
      .replace(' DO ', ' ')
      .replace(' DOS ', ' ')
      .split(' ')
      .slice(0, 2)
      .join(' ');
  }
  return '';
}

function formatNomeArquivo(nome) {
  if (typeof nome === 'string') {
    return nome.toLowerCase()
      .replace('/', ' ')
      .split(' ')
      .join('-');
  }
  return '';
}

export {
  normalizar,
  pesquisar,
  formatNomeSobrenome,
  formatNomeArquivo,
};
